export enum ReweighLogDetailsViewType {
  DEFAULT = 'default',
  DISPUTES = 'disputes',
}
